import { Component, Input } from '@angular/core';
import { Achievement } from '../models';

@Component({
  selector: 'app-garmin-record',
  templateUrl: './garmin-record.component.html',
  styleUrls: ['./garmin-record.component.scss'],
})
export class GarminRecordComponent {

  @Input() achievement: Achievement;
  @Input() type;
  constructor() { }


}
